import styled from 'styled-components';
import { BodyBoldS, LabelRegularBoldM } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';

export const NAME_CELL_WIDTH = '50%';
export const DETAILS_CELL_WIDTH = '50%';
export const TEAM_CELL_WIDTH = '50%';
export const ROLE_CELL_WIDTH = '50%';
export const DATA_CELL_WIDTH = '50%';

export const TableFooter = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  justify-self: center;
  width: 672px;
  margin: 8px auto 16px;
`;

export const TableTitle = styled(BodyBoldS)`
  text-transform: capitalize;
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `}
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 16px 16px 0 80px;
  #TableTileCont {
    ${({ theme }: IThemeProvider) => `
      background: ${theme.colors.neutral.primary[5]};
    `}
  }
`;

export const Header = styled.div`
  border-width: 1px 0px;
  display: flex;
  align-items: center;
  border-style: solid;
  height: 48px;
  padding: 0 32px 0 32px;
  margin: 8px 0;
  ${({ theme }: IThemeProvider) => `
    border-color: ${theme.colors.neutral.primary[30]};
  `}
`;

export const Data = styled(LabelRegularBoldM)`
  text-transform: uppercase;
  letter-spacing: 0.08em;
  width: ${DATA_CELL_WIDTH};
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `}
`;

export const NameColumn = styled(Data)`
  width: ${NAME_CELL_WIDTH};
`;

export const DetailsCont = styled.div`
  display: flex;
  flex-direction: row;
  width: ${DETAILS_CELL_WIDTH};
`;

export const TeamColumn = styled(Data)`
  width: ${TEAM_CELL_WIDTH};
`;

export const RoleColumn = styled(Data)`
  width: ${ROLE_CELL_WIDTH};
`;

export const RowsPerPageContainer = styled.div`
  margin-right: 5px;
`;
